import { Component, EventEmitter, Input, OnInit, Output, SkipSelf } from '@angular/core';
import { OnDestroyMixin } from '@w11k/ngx-componentdestroyed';

import { defs } from '../../defs';
import { ExchangeCartService } from '../exchange-cart.service';
import { DigitsInfo } from '../../bo/digitsInfo'
import { GlitterOfferBaseDto, GlitterOfferDto } from '../../api';
import { PriceService } from '../../price.service';
import { AuthService } from '../../shared/auth/auth.service';
import { LoginModalService } from '../../shared/login/login-modal.service';
import { ExchangeService } from '../exchange.service';
import { CancelModalService } from './cancel/cancel-modal.service';

@Component({
	selector: 'narwhalia-exchange-card',
	templateUrl: './exchange-card.component.html',
	styleUrls: ['./exchange-card.component.scss'],
	providers: [PriceService]
})
export class ExchangeCardComponent extends OnDestroyMixin implements OnInit {
	@Input() card: GlitterOfferDto;
	@Output() cancelOfferEmitter: EventEmitter<string>;
	digitsInfo: DigitsInfo;
	showSellGlitterPopup: boolean;

	constructor(
		private exchangeCartService: ExchangeCartService,
		private priceService: PriceService,
		@SkipSelf() private globalPriceService: PriceService,
		private authService: AuthService,
		private loginModalService: LoginModalService,
		private exchangeService: ExchangeService,
		private cancelModalService: CancelModalService
	) {
		super();
		this.digitsInfo = defs.digitsInfo;
		this.cancelOfferEmitter = new EventEmitter<string>();
		this.showSellGlitterPopup = false;
	}

	ngOnInit() {
		this.card = GlitterOfferBaseDto.mixin(this.card)
		if (this.card.price) {
			this.getActualPrice();
		}
	}

	getActualPrice() {
		this.priceService
			.getActualPrice(this.card.price, this)
			.subscribe(actualPrice => {
				this.card.actualPrice = actualPrice;
				this.globalPriceService.priceUpdated$.next();
			});
	}

	addToCart(item: GlitterOfferDto) {
		if (this.authService.isLoggedIn()) {
			this.exchangeCartService.addItemToCart(item);
		} else {
			this.loginModalService.open();
		}
	}

	cancelOffer(id: string) {
		this.cancelModalService.open();
		this.cancelModalService.dialogRef.afterClosed().subscribe(() => {
			if (this.cancelModalService.dialogRef.componentInstance.isConfirmed) {
				this.exchangeService.cancelOffer(id).subscribe(result => {
					this.cancelOfferEmitter.emit(id);
				});
			}
		});
	}

	activateOffer(activatedOffer: GlitterOfferDto) {
		this.card = activatedOffer;
		this.getActualPrice();
	}

	closePopup() {
		this.showSellGlitterPopup = false;
	}

	togglePopup(event) {
		event.preventDefault();
		event.stopPropagation();
		this.card.sale.id = this.card.id;
		this.showSellGlitterPopup = !this.showSellGlitterPopup;
	}
}